/** @jsxImportSource @emotion/react */

export type MultiSelectFilterValue = string[] | null;
export type MultiSelectFilterOption = { value: string; label: string };

export const defaultSelect: MultiSelectFilterValue = null;

export type MultiSelectFilterProps = {
  value: MultiSelectFilterValue;
  options?: MultiSelectFilterOption[];
  onChange(value: MultiSelectFilterValue): void;
};

export function MultiSelectFilter({ onChange, ...props }: MultiSelectFilterProps) {
  const value = props.value ?? defaultSelect;
  const options = props.options ?? [];

  const filterChangeHandler = (option: MultiSelectFilterOption & { checked: boolean }) => {
    const newValue = option.checked
      ? [...(value || []), option.value]
      : (value || []).filter((v) => v !== option.value);
    onChange(newValue);
  };

  return (
    <>
      <div className="lp-w-full mb-16">
        <div className="mulitiselectcheckboxes">
          {options.map((option) => (
            <div className="filter-input" key={option.value}>
              <input
                type="checkbox"
                id={`${option.value}-filter-checkbox`}
                checked={value?.includes(option.value) || false}
                onChange={(e) => filterChangeHandler({ ...option, checked: e.target.checked })}
                data-testid={`${option.value}-filter-checkbox`}
              />
              <label className="filter-checkbox-label" htmlFor={`${option.value}-filter-checkbox`}>
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
